import { gsap, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default () => {
  let mm = gsap.matchMedia();
  ScrollTrigger.defaults({
    toggleActions: 'restart pause resume pause',
    markers: window.location.hostname.endsWith('.local') ? true : false,
  });

  //------------------------------------------------------//
  // On browser 📜 scroll full window height
  //------------------------------------------------------//
  ScrollTrigger.create({
    id: 'Scrolled',
    trigger: 'body',
    start: `${window.innerHeight * 1.5} bottom`,
    toggleClass: 'showScrolled',
  });
  // END On browser 📜 scroll full window height
  // -------------------------------------//
  //--------------------------------//
  // Menu toggle animation
  //--------------------------------//
  // Menu toggle setup
  let tlMenuToggleAll = [];  // Collect all menu buttons;
  const menuToggle = document.querySelectorAll('.menu-toggle');
  // Animation function
  function menuToggleAnimation(target) {
    const q = gsap.utils.selector(target);
    // Menu toggle animation
    const tl = gsap.timeline({
      paused: true,
      reversed: true,
      defaults: { duration: 0.3, ease: 'power3.in' },
      onComplete: () => target.setAttribute('aria-expanded', true),
      onReverseComplete: () => target.setAttribute('aria-expanded', false),
    });
    // // ---- Simple ----
    // tl.to(q(".anim"), {rotate: gsap.utils.wrap([-45, 45])});
    // tl.to(q(".anim"), { y: 0 }, "<");
    // tl.to(q(".text"), { duration: 0.1, opacity: 0 }, "<");

    //   // ---- Spinning ----
    //   tl.to(q(".inner"), { duration: 0.8, rotate: 360 * 3 });
    //   tl.to(q(".anim"), { y: 0 }, "<");
    //   tl.to(q(".text"), { duration: 0.1, opacity: 0 }, "<");
    //   tl.to(q(".anim"), {
    //     duration: 0.45,
    //     rotate: gsap.utils.wrap([45 * 3, 45 * 5])
    //   }, "-=0.6");

    // // ---- Rotate ----
    // tl.to(q(".inner"), { rotate: -90 });
    // tl.to(q(".anim"), { y: 0 }, "<");
    // tl.to(q(".anim"), {rotate: gsap.utils.wrap([45, -45])});
    // tl.to(q(".text"), { duration: 0.1, opacity: 0 }, "<");

    // // ---- Move out in ----
    // tl.to(q(".inner span"), { xPercent: -150, stagger: 0.1 });
    //   tl.set(q(".anim"), { y: 0 });
    // tl.set(q(".anim"), {
    //   duration: 0.45,
    //   rotate: gsap.utils.wrap([45 * 3, 45 * 5])
    // });
    // tl.set(q(".text"), { opacity: 0 }, "<");
    // tl.set(q(".inner span"), { xPercent: 0 });
    // tl.set(q(".inner .anim"), { xPercent: 150 });
    // tl.to(q(".inner .anim"), { xPercent: 0 });

    // ---- Rotate animation ----
    tl.to(q('.anim'), { y: 0 });
    tl.to(q('.anim'), {
      duration: 0.45,
      rotate: gsap.utils.wrap([45 * 3, 45 * 5]),
    });
    tl.to(q('.text'), { duration: 0.1, opacity: 0 }, '<');
    tlMenuToggleAll.push(tl);  // Capture all timelines
    return tl;
  }

  function toggleAnimation(dialogId) {
    if (dialogId === 'navigation-slide') {
      tlMenuToggleAll.forEach((tl) => {
        tl.reversed() ? tl.play() : tl.reverse();
      });
    }
  }

  document.querySelectorAll('.menu-toggle').forEach((item) => {
    const q = gsap.utils.selector(item);
    const offset = item.getBoundingClientRect().height * 0.2;
    // Animate only if item is a button
    if (item.tagName === 'BUTTON') {
      gsap.set(q('.anim'), {
        y: gsap.utils.wrap([offset, -offset]),
        duration: 0.15,
        ease: 'power4.in',
      });
      gsap.set(q('.text'), { opacity: 1 });
      // Create animation
      menuToggleAnimation(item);
    }
  });
  // END Menu slide animation --------------//
  // END Menu toggle animation --------------//

  //--------------------------------//
  // Dialog logic
  //--------------------------------//
  document.querySelectorAll('.dialog-open').forEach(button => {
    button.addEventListener('click', (event) => {
      const dialogId = button.getAttribute('aria-controls');
      const dialog = document.getElementById(dialogId);

      if (dialog) {
        document.querySelector('#live-region').textContent =
          dialog.dataset.liveOpen;
        dialog.showModal();
        dialog.setAttribute('aria-expanded', true);
        toggleAnimation(dialogId);
      }
    });
  });

  document.querySelectorAll('.dialog-close').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll('dialog[open]').forEach(dialog => {
        document.querySelector('#live-region').textContent =
          dialog.dataset.liveClose;
        dialog.close();
        dialog.setAttribute('aria-expanded', false);
        toggleAnimation(dialog.id);
      });
    });
  });

  // Close dialog when clicking outside of its content
  document.addEventListener('click', (event) => {
    const openDialogs = document.querySelectorAll('dialog[open]');

    openDialogs.forEach(dialog => {
      if (event.target === dialog) {
        dialog.close();
        dialog.setAttribute('aria-expanded', false);
        toggleAnimation(toggleAnimation(dialog.id));
      }
    });
  });
  // END Dialog elements --------------//

  //--------------------------------//
  // S&F toggle show hide 
  //--------------------------------//
  if (document.querySelector('.alloy-filter-slide_over-toggle')) {
    const tl = gsap.timeline({

      scrollTrigger: {
        id: 'FilterScrolled',
        trigger: '#alloy-sf-everything',
        start: `top top`,
        end: `bottom bottom`,
        toggleActions: 'play reverse play reverse',
      }
    });
    tl.from('.alloy-filter-slide_over-toggle', {
      y: 200,
    })
  }
  // END S&F toggle show hide --------------//


};
